import * as React from 'react';

export const CloseBlackBox: ReactFCWithChildren<JSX.IntrinsicElements['svg']> = (props) => (
  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="25" height="25">
    <g fill="none" fillRule="evenodd">
      <rect width="25" height="25" rx="4" fill="#000" fillOpacity=".4" />
      <path
        fill="#FFF"
        d="M7.904 17.096a.813.813 0 010-1.15l3.447-3.445-3.448-3.448a.813.813 0 011.15-1.15l3.447 3.449 3.448-3.448a.812.812 0 111.148 1.15L13.65 12.5l3.446 3.446a.812.812 0 11-1.149 1.15L12.5 13.65l-3.446 3.446a.812.812 0 01-1.15 0z"
      />
    </g>
  </svg>
);

export default CloseBlackBox;
